'use-client';
import PinterestPinIt from '../../PinterestPinIt';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';

export default WithConsentPolicy(PinterestPinIt, {
  componentConsentPolicy: { advertising: true },
});
